var map = {
	"./About.jsx": 2249,
	"./Contact.jsx": 3185,
	"./Contact/Start-A-Project.jsx": 885,
	"./Home.jsx": 5148,
	"./Services.jsx": 3577,
	"./Works.jsx": 2679,
	"./index.jsx": 1952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6298;